
<template>
    <div class="email-banner">
        <p class="title is-size-3 prompt has-text-white" style="margin-bottom: 15px; color:white !important">Updates in Your Inbox?</p>
        <!-- Begin Mailchimp Signup Form -->
        <!-- <link href="//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css" rel="stylesheet" type="text/css"> -->
        <!-- <style type="text/css">
            #mc_embed_signup{background:#fff; clear:left; font:14px Helvetica,Arial,sans-serif; width:100%;}
            /* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
            We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
        </style> -->
        <div id="mc_embed_signup">
        <form action="https://bikesleepbike.us7.list-manage.com/subscribe/post?u=c689107147db62a56a5c64fd4&amp;id=d755fae67a" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
            <div id="mc_embed_signup_scroll">
                <p class="" style="margin-top: 0; margin-bottom: 20px;">Stay in the loop with occasional announcements and selected new bike travel blogs, straight to your inbox.</p>
            
            <b-input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address" required style="display:block; width:100%"></b-input>
            <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
            <div style="position: absolute; left: -5000px; display:inline" aria-hidden="true">
                <input type="text" name="b_c689107147db62a56a5c64fd4_d755fae67a" tabindex="-1" value="" style="font-size:20px">
            </div>
            <div class="clear" style="display:block;">
                <input type="submit" value="Sign up!" name="subscribe" id="mc-embedded-subscribe" class="button submit-button" ></div>
            </div>
        </form>
        <p class="" style="margin-top: 20px; margin-bottom: 0px;">You can also <a href="https://www.facebook.com/bikesleepbike" target="_blank" style="color:#f37d5e"> follow BSB on Facebook</a>.</p>
        </div>
        
        <!--End mc_embed_signup-->
    </div>
</template>

<script>
export default {
  name: 'EmailForm',
  components: {  },
  data () {
    return {
    }
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (max-width: 789px) {
    .submit-button {
        width: 100%;
        /* margin-top: 15px;
        margin-bottom: 10px;
        margin-left: 0; */
    }
    input.email {
        width: 100%;
        padding: 5px;
        text-align: center;
        margin-top: 10px;
    }
}
input.email {
    /* width: 370px; */
    padding: 10px 10px;
    border: 1px solid #dbdbdb;
    border-radius: 5px;
}
.submit-button {
    color: white;
    /* width: 150px; */
    /* margin-left: 10px; */
    font-size:1.2em;
    margin-top:15px;
    border: none;
    min-width: 200px;
    padding:10px 20px;
    height:auto;
}


.email-banner {
    /* background-color: #f37d5e; */
    /* background-color: #e8f9ff; */
    padding: 40px 20px;
}
.email-banner #mc_embed_signup .button {
    background-color: #2763a1;
    background-color: #f37d5e;
    /* font-size: 16px !important; */
    /* height: 40px !important; */
}
.email-banner #mc_embed_signup .button:hover {
    background-color: #458eda;
    background-color: #ff8239;
}
.email-banner input.email {
    font-size: 18px !important;
    height: 40px !important;
}
.prompt {
    color: white;
    color: #f37d5e;
    color: #2763a1;
}

</style>


// WEBPACK FOOTER //
// src/components/EmailForm.vue